import * as apiGetStartingWithV1 from 'api/nutriScoreLabel/GetNutriScoreLabelGroupedStartingWithV1';
import * as NutriScoreLabel from 'types/NutriScore/NutriScoreLabel';

export type Type = NutriScoreLabel.Type[];

export function create(): Type {
	return [];
}

export async function getFromApi(): Promise<Type> {
	const response = await apiGetStartingWithV1.callApi('', false);
	return response.getOrDefault([]);
}
